(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mms-legacy-compatibility"]) return;
  try {
    
if (!window.mmsLegacyCartBridge) {
  window.mmsLegacyCartBridge = true;
  let navigating = false;
  let opening = false;
  let refreshAgain = false;
  const openCart = async () => {
    const destination = document.querySelector('[data-mms-legacy-cart-url]');
    if (!destination || navigating) return;
    // A managed native bundle owns its success rendering after server verification.
    if (document.querySelector('mila-device-bundle[data-cart-add-pending=true]')) return;
    const drawer = document.querySelector('cart-drawer');
    const usePageCart = () => {
      if (navigating) return;
      navigating = true;
      window.location.assign(destination.dataset.mmsLegacyCartUrl);
    };
    if (!drawer || typeof drawer.renderContents !== 'function') {
      usePageCart();
      return;
    }
    if (opening) {
      refreshAgain = true;
      return;
    }
    opening = true;
    try {
      const url = new URL(destination.dataset.mmsLegacyCartUrl, window.location.origin);
      url.searchParams.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Section request HTTP ' + response.status);
      const sections = await response.json();
      if (!sections['cart-drawer']) throw new Error('Section cart-drawer missing or empty');
      if (!sections['cart-icon-bubble']) throw new Error('Section cart-icon-bubble missing or empty');
      const source = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (!source) throw new Error('Section cart-drawer is missing its cart-drawer element');
      // App events are not proof of an add. Never open an automatically refreshed empty drawer.
      // The header cart button still opens an empty cart directly when explicitly requested.
      if (source.classList.contains('is-empty') && document.querySelector('mila-device-bundle[data-native-product-id="15443829129464"]')) return;
      if (document.querySelector('mila-device-bundle[data-cart-add-pending=true]')) return;
      drawer.classList.toggle('is-empty', source.classList.contains('is-empty'));
      drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      drawer.renderContents({ sections });
      window.mmsCwtShippingProgress?.refresh();
    } catch (error) {
      console.warn('[MMS cart] Drawer refresh failed; opening cart page.', error instanceof Error ? error.message : 'Unknown rendering error');
      usePageCart();
    } finally {
      opening = false;
      if (refreshAgain && !navigating) {
        refreshAgain = false;
        openCart();
      }
    }
  };
  document.addEventListener('ajaxProduct:added', openCart);
  document.addEventListener('cart:open', openCart);
}

  } catch(e) { console.error(e); }
})();
})();
